var map = {
	"./COGNEESOL_LOGO.png": 20766,
	"./FWS_LOGO.png": 94131,
	"./activeAudits.svg": 24565,
	"./agent.svg": 53237,
	"./auditAgent.svg": 78543,
	"./auditAuditor.svg": 10224,
	"./auditCalendar.svg": 93843,
	"./auditClient.svg": 1207,
	"./auditCount.svg": 23811,
	"./auditDepartment.svg": 18156,
	"./auditFatel.svg": 62141,
	"./auditForm.svg": 57051,
	"./auditId.svg": 12280,
	"./auditInsure.svg": 96030,
	"./auditNoFatel.svg": 17985,
	"./auditProcess.svg": 71365,
	"./auditScore.svg": 53489,
	"./auditScoree.svg": 11506,
	"./auditStag.svg": 23551,
	"./auditTransaction.svg": 4552,
	"./audited.svg": 84607,
	"./auditor.svg": 71140,
	"./dashboardIcon.svg": 52676,
	"./dashboardUser.svg": 46843,
	"./departmentAction.svg": 16145,
	"./departmentDate.svg": 16112,
	"./departmentIcon.svg": 42385,
	"./departmentName.svg": 1634,
	"./departmentStatus.svg": 1779,
	"./downloadIcon.svg": 97060,
	"./fatelCount.svg": 9387,
	"./invoiceCount.svg": 841,
	"./link.svg": 21934,
	"./manageUsers.svg": 44871,
	"./menuIcon.svg": 54570,
	"./noData.svg": 33848,
	"./nonFatelCount.svg": 87794,
	"./profileIcon.svg": 39028,
	"./qmsIcon.svg": 28130,
	"./reasonIcon.svg": 63845,
	"./searchIcon.svg": 43067,
	"./settingsIcon.svg": 76085,
	"./supervisor.svg": 86263,
	"./surveyLogo.svg": 73239,
	"./totalAudits.svg": 58416,
	"./transactionId.svg": 65722,
	"./voc.svg": 83218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60190;